import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Shield, User, Lock } from "lucide-react";
import AuthLayout from "../components/AuthLayout";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const nav = useNavigate();
  const { adminLogin } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { username, password });
      adminLogin(data.token);
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-rv-orange bg-rv-orange/10 border border-rv-orange/25 rounded-full px-3 py-1 mb-4">
        <Shield size={13} /> Admin console
      </div>
      <h2 className="text-2xl font-extrabold mb-1" data-testid="admin-login-title">Admin sign in</h2>
      <p className="text-rv-sub text-sm mb-7">Manage users, access codes and playlists.</p>

      {err && <div className="mb-4 text-sm text-rv-red bg-rv-red/10 border border-rv-red/30 rounded-xl px-4 py-3" data-testid="admin-login-error">{err}</div>}

      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs font-semibold text-rv-sub mb-1.5 block">Username</label>
          <div className="relative">
            <User size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-rv-muted" />
            <input required value={username} onChange={(e) => setUsername(e.target.value)} placeholder="admin" className="field pl-10" data-testid="admin-username-input" />
          </div>
        </div>
        <div>
          <label className="text-xs font-semibold text-rv-sub mb-1.5 block">Password</label>
          <div className="relative">
            <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-rv-muted" />
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="field pl-10" data-testid="admin-password-input" />
          </div>
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2" data-testid="admin-login-submit-button">
          {loading ? <span className="spinner" /> : <Shield size={18} />}
          {loading ? "Signing in…" : "Enter console"}
        </button>
      </form>

      <p className="text-center text-sm text-rv-sub mt-6">
        <Link to="/login" className="text-rv-cyan font-semibold hover:underline">Back to app</Link>
      </p>
    </AuthLayout>
  );
}
